import { render, staticRenderFns } from "./UsersActivity.vue?vue&type=template&id=3624f504"
import script from "./UsersActivity.vue?vue&type=script&lang=js"
export * from "./UsersActivity.vue?vue&type=script&lang=js"
import style0 from "./UsersActivity.vue?vue&type=style&index=0&id=3624f504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports